package com.castly.admin.dto

import kotlinx.serialization.Serializable

/**
 * Response containing time-limited streaming URL for episode audio
 * Used by GET /api/v1/episodes/{id}/stream endpoint
 *
 * Frontend copy (Kotlin/JS compatible)
 */
@Serializable
data class StreamingUrlResponse(
    val streamingUrl: String,       // CloudFront signed URL
    val expiresIn: Long             // Seconds until URL expiration
)
